'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _Portal = require('react-overlays/lib/Portal');

var _Portal2 = _interopRequireDefault(_Portal);

var _reactMotionUiPack = require('react-motion-ui-pack');

var _reactMotionUiPack2 = _interopRequireDefault(_reactMotionUiPack);

var _DomAlign = require('react-overlay-pack/lib/DomAlign');

var _DomAlign2 = _interopRequireDefault(_DomAlign);

var _ClickOutside = require('react-overlay-pack/lib/ClickOutside');

var _ClickOutside2 = _interopRequireDefault(_ClickOutside);

var _emptyFunction = require('../utils/emptyFunction');

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/no-find-dom-node: 0 */

var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Overlay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call.apply(_ref, [this].concat(args))), _this), _this.onClickOutSide = function (e) {
      var node = (0, _reactDom.findDOMNode)(_this.props.target);
      if (node && node.contains(e.target)) return; // Hint: Omit clicking target.

      _this.props.onClickOutSide(e);
    }, _this.renderChildrenWithStyle = function () {
      return _react2.default.cloneElement(_this.props.children, {
        style: _extends({}, _this.props.children.style, { position: 'absolute' })
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Overlay, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Portal2.default,
        null,
        _react2.default.createElement(
          _ClickOutside2.default,
          { onClick: this.onClickOutSide },
          _react2.default.createElement(
            _DomAlign2.default,
            { config: this.props.alignConfig, target: this.props.target },
            _react2.default.createElement(
              _reactMotionUiPack2.default,
              this.props.transitionConfig,
              this.renderChildrenWithStyle()
            )
          )
        )
      );
    }
  }]);

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = {
  onClickOutSide: _propTypes2.default.func, // for ClickOutside
  children: _propTypes2.default.node.isRequired,
  target: _propTypes2.default.object, // react mounted instance
  alignConfig: _propTypes2.default.object, // docs: https://github.com/yiminghe/dom-align#alignconfig-object-details
  transitionConfig: _propTypes2.default.object // docs: https://github.com/souporserious/react-motion-ui-pack#props
};
Overlay.defaultProps = {
  onClickOutSide: _emptyFunction2.default,
  alignConfig: {
    points: ['tr', 'br'], // bottom-right
    offset: [0, 0]
  },
  transitionConfig: {
    component: false,
    enter: {
      translateY: 0
    },
    appear: {
      translateY: -5
    }
  }
};
exports.default = Overlay;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/Overlay/Overlay.js
// module id = 521
// module chunks = 4